export function jsDateFromAspDateString(aspDateString: Date | string) {
  if (aspDateString instanceof Date) return aspDateString;
  if (aspDateString.startsWith("/Date(")) {
    return new Date(Number(aspDateString.substring(6, aspDateString.length - 2)));
  }
  return new Date(aspDateString);
}

export function toAspDateString(date: Date) {
  return `/Date(${date.getTime()})/`;
}
